














import Vue from "vue";
import * as routes from "@/router/routes";

// Vue components
import StandardPage from "@/components/PageTemplates/StandardPage.vue";
import ContentMainTable from "./ContentMainTable.vue";

// Model
import { dataTableItemsPerPage } from "@/utility/Constants";
import { FetchInstallationsContentCommand, FetchInstallationsContentRequestData } from "@/model/communication/content/FetchInstallationsContentCommand";
import { FetchInstallationsContentResponse } from "@/model/communication/content/FetchInstallationsContentResponse";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { DownloadCashContentReportCommand } from "@/model/communication/content/DownloadCashContentReportCommand";


export default Vue.extend({
    components: {
        StandardPage,
    },
    data() {
        return {
            routes,
            dataTableItemsPerPage,
            ContentMainTable,
            reqData: null,
            installations: [],
            paginatedTotalItems: null,
            loading: false,
        };
    },
    methods: {
        async sendRequest(request) {
            try {
                this.reqData = request;
                this.loading = true;
                var response: FetchInstallationsContentResponse = await new FetchInstallationsContentCommand(request).execute();
                this.loading = false;

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installations = response.installationsList;
                    this.paginatedTotalItems = response.totalInstallationsCount;
                }
            } catch (e) {
                console.log("Something went wrong sending FetchInstallationsContentCommand request ", e);
                this.loading = false;
            }
        },
        async onDownload(exportType) {
            console.log("Download cash content report required, exportType: ", exportType);
            if (!this.loading) {
                this.loading = true;
                try {
                    var res;
                    switch (exportType) {
                        case "csv":
                            res = await new DownloadCashContentReportCommand(exportType, this.reqData).execute();
                            break;
                    }
                    var fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    var fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                    document.body.appendChild(fileLink);
                    fileLink.click();

                    this.loading = false;
                } catch (e) {
                    console.log("Something went wrong during DownloadCashContentReportCommand execution: ", e);
                    this.loading = false;
                }
            }
        },
    },
    mounted() {
        // await this[a.ON_OPEN_PAGE]();
        this.reqData = new FetchInstallationsContentRequestData();
        this.reqData.queryLimit = this.dataTableItemsPerPage[0];
    },
});
